import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-inner">
        <Link to="/" className="nav-brand">
          <div className="nav-logo">
            <span className="nav-logo-char">ध</span>
          </div>
          <span className="nav-company">DhanAcademy</span>
        </Link>

        <div className="nav-links">
          <Link to="/glossary" className={`nav-link ${location.pathname.startsWith('/glossary') ? 'active' : ''}`}>Glossary</Link>
          <Link to="/topics" className={`nav-link ${location.pathname.startsWith('/topic') ? 'active' : ''}`}>Topics</Link>
          <Link to="/mistakes" className={`nav-link ${location.pathname.startsWith('/mistakes') ? 'active' : ''}`}>Mistakes</Link>
          <Link to="/tools/sip" className={`nav-link ${location.pathname.startsWith('/tools') ? 'active' : ''}`}>Tools</Link>
          <Link to="/disclaimer" className={`nav-link ${location.pathname === '/disclaimer' ? 'active' : ''}`}>About</Link>
        </div>
      </div>
    </nav>
  );
}
